// extracted by mini-css-extract-plugin
module.exports = {"action":"download-button_action__3bkbl","icon":"download-button_icon__2RUC2"};